function SuccessMessage({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div 
        className="rounded-md border border-gray-300 bg-green-500  py-2 px-3 mb-3"
        {...props}
    />
  )
}

export { SuccessMessage }
